// @flow

/* Libs */
import React from 'react';
import { Route, Switch } from 'react-router-dom';

/* Components */
import CategoriesFurnitures from './CategoriesFurnitures';
import CategoryFurnitures from './CategoryFurnitures';

/* Styles */
import './Furnitures.scss';

const Furnitures = () => (
	<div className="App-Furnitures">
		<Switch>
			<Route path="/inventory/furnitures" exact>
				<CategoriesFurnitures />
			</Route>

			<Route path="/inventory/furnitures/:categoryid/new">
				<CategoryFurnitures />
			</Route>

			<Route path="/inventory/furnitures/:categoryid/:furnitureid">
				<CategoryFurnitures />
			</Route>

			<Route path="/inventory/furnitures/:categoryid">
				<CategoryFurnitures />
			</Route>

		</Switch>
	</div>
);

export default Furnitures;
